var exports = {
  "Ag": "StackSection__IFzfkO",
  "XE": "StackSectionLoadingSpinner__3CoUbe",
};

module.exports = exports;
